import React, { useState } from 'react';
import { Alert, Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import { FileAltIcon, FileIcon, UserIcon } from '@nimbus-ds/icons';
import { FormattedMultilineText } from 'commons/components';
import DocumentUploader from 'commons/components/DocumentUploader';
import { useTranslationWithPrefix } from 'commons/utils';
import StatuteDocumentSkeleton from './StatuteDocumentSkeleton';

interface InterfaceDniDoc {
  statuteThumbnailFile?: string;
  verifyUploadedDocuments: React.Dispatch<React.SetStateAction<boolean>>;
}

function StatuteDocument({
  statuteThumbnailFile = '',
  verifyUploadedDocuments,
}: InterfaceDniDoc): JSX.Element {
  const { t } = useTranslationWithPrefix('identityValidation');
  const [errorText, setErrorText] = useState({
    show: false,
    text: '',
  });

  const handleOnSuccess = () => {
    verifyUploadedDocuments(true);
    setErrorText({
      show: false,
      text: '',
    });
  };

  const handleOnError = (text: string) => {
    verifyUploadedDocuments(false);
    setErrorText({
      show: text.length > 0,
      text,
    });
  };

  const handleOnDelete = () => {
    verifyUploadedDocuments(false);
  };

  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('juridical.statute.title')}</Title>
      </Card.Header>
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
        <Box display="flex" flexDirection="row" gap="2" alignItems="center">
          <Icon
            source={<UserIcon size="medium" />}
            color="primary-interactive"
          />
          <Text>{t('juridical.statute.details')}</Text>
        </Box>
        <Box display="flex" flexDirection="row" gap="2" alignItems="center">
          <Icon
            source={<FileAltIcon size="medium" />}
            color="primary-interactive"
          />
          <Text>{t('juridical.statute.authorizedPeople')}</Text>
        </Box>
        <Box display="flex" flexDirection="row" gap="2" alignItems="center">
          <Icon
            source={<FileIcon size="medium" />}
            color="primary-interactive"
          />
          <FormattedMultilineText formattedFontWeight="bold">
            {t('juridical.statute.documentFormat')}
          </FormattedMultilineText>
        </Box>
        <Alert
          show={errorText.show}
          appearance="danger"
          title={t('errors.title')}
          onRemove={() => setErrorText({ show: false, text: '' })}
        >
          {errorText.text}
        </Alert>
        <Box display="flex" maxWidth="400px">
          <DocumentUploader
            aspectRatio="2/1"
            documentName="companyComposition"
            onSuccess={handleOnSuccess}
            onError={handleOnError}
            ariaLabel="statute"
            helperText={t('juridical.statute.chooseFile')}
            accept="image/jpeg,image/png,application/pdf"
            initialThumbnailFile={statuteThumbnailFile}
            onDelete={handleOnDelete}
            autoUpload={true}
            errorEventName="pago-nube-prueba-de-vida-documento-error"
          />
        </Box>
      </Box>
    </Card>
  );
}

StatuteDocument.Skeleton = StatuteDocumentSkeleton;
export default StatuteDocument;
